import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrown = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5 19h14a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Zm7.8-13.4 3.2 4.267 3.446-2.584a1 1 0 0 1 1.596.94l-1.2 7.2A1 1 0 0 1 18.856 17H5.144a1 1 0 0 1-.986-.836l-1.2-7.2a1 1 0 0 1 1.596-.94L8 10.607 11.2 6.34a1 1 0 0 1 1.6 0Z" })
});
export default SvgCrown;
